//core
import React from 'react'
//@material-ui
import Container from '@material-ui/core/Container'
// import { Box, Grid } from '@material-ui/core'
import { Grid } from '@material-ui/core'
//component
// import { Link } from 'react-router-dom'
//bussiness
import Logo1 from '../assets/img/logo-1.png'
import Ad from '../assets/img/60ad.gif'


function HeaderLogo(props){
    // const [images, setimages] = useState([
    //     {src: Logo1,alt: 'Logo'},
    //     {src: Ad,alt: '60ad'}
    // ])
    // const images = [
    //     {src: Logo1,alt: 'Logo'},
    //     {src: Ad,alt: '60ad'}
    // ];
    return (
        // <Box component={Container} maxWidth="xl" fixed paddingTop={5}>
        <Container maxWidth="xl" fixed>
            <Grid spacing={3} container>
            {/* logo图片 */}
                <Grid style={{paddingTop:'27px'}} item xs={12} sm={5} md={4} lg={3} xl={2}>
                    <a href='#polo'>
                        <img src={Logo1} alt='Logo'
                        style={{height: 60,width: 'auto',}}/>
                    </a>
                </Grid>
                <Grid style={{paddingTop:'27px'}} item xs={12} sm={3} md={4} lg={3} xl={2}>
                    <a href='#polo'>
                        <img src={Ad} alt='60ad'
                        style={{height: 60,width: 'auto',}}/>
                    </a>
                </Grid>
                <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                    <span style={{font:'400 26px/100px "microsoft yahei"'}}>分供商注册</span>
                </Grid>
            </Grid>
        </Container>
    )
}

export default HeaderLogo;